import React from "react";
import "../css/others/Popup.css";
import { AccountNamePopupProps } from '../interFaces/interfaces';
const AccountNamePopup: React.FC<AccountNamePopupProps> = ({ formula, onClose }) => {
  return (
    <div className="accountname-overlay">
      <div className="accountname-content">
        <div className="accountname-header">
          <h3>Account Names</h3>
          <button className="accountname-close-button" onClick={onClose}>&times;</button>
        </div>
        <div className="accountname-body">
          <div className="display-screen1">{formula}</div>
        </div>
        <div className="accountname-footer">
          <button className="accountname-button" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
};
export default AccountNamePopup;